
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32.1 7.1c-.6-.1-1.1.3-1.2.8l-3.3 17H6.4l-3.3-17c-.1-.5-.7-.9-1.2-.8-.5.1-.9.7-.8 1.2l3.5 17.8c.1.5.5.8 1 .8h22.8c.5 0 .9-.3 1-.8l3.5-17.8c.1-.5-.3-1.1-.8-1.2z","fill":"#47AEA6"}}),_c('path',{attrs:{"d":"M2.9 12.6h28.2","stroke":"#47AEA6","stroke-width":"2","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M12.1 17.7c0 .4-.1.7-.3 1-.2.3-.6.4-1 .5.5.1.9.2 1.1.4.3.2.4.6.4 1 0 .6-.2 1-.6 1.4-.4.4-1 .5-1.8.5-.7 0-1.2-.1-1.8-.3v-1.1c.2.1.5.2.8.3.3.1.6.1.8.1.4 0 .7-.1.9-.2.2-.1.3-.4.3-.7 0-.3-.1-.5-.3-.6-.2-.1-.6-.2-1.1-.2H9v-1h.5c.5 0 .8-.1 1-.2.2-.1.3-.3.3-.6 0-.5-.3-.7-.9-.7-.2 0-.4 0-.6.1-.2.1-.4.2-.7.3l-.6-.9c.6-.4 1.2-.6 2-.6.6 0 1.1.1 1.5.4.4.3.6.7.6 1.1zm5.1 1.7c0 1.1-.2 1.9-.5 2.4s-.9.8-1.6.8c-.7 0-1.2-.3-1.6-.8-.4-.5-.5-1.3-.5-2.3 0-1.1.2-1.9.5-2.4s.9-.8 1.6-.8c.7 0 1.2.3 1.6.8.3.5.5 1.3.5 2.3zm-3 0c0 .7.1 1.3.2 1.6.1.3.3.5.7.5.3 0 .5-.2.6-.5.1-.3.2-.9.2-1.6 0-.7-.1-1.3-.2-1.6-.1-.3-.4-.5-.6-.5-.3 0-.5.2-.6.5-.2.3-.3.8-.3 1.6zm6.4-1.6c0 .5-.1.8-.4 1.1-.3.3-.6.4-1 .4s-.8-.1-1-.4c-.3-.3-.4-.6-.4-1.1 0-.5.1-.8.4-1.1.2-.3.6-.4 1.1-.4.4 0 .8.1 1 .4.1.3.3.6.3 1.1zm-2 0c0 .3 0 .5.1.6.1.1.2.2.4.2s.3-.1.4-.2c.1-.1.1-.3.1-.6s0-.5-.1-.6c0-.2-.2-.2-.4-.2s-.3.1-.4.2c-.1.1-.1.3-.1.6zm5.6-.5c-.5 0-.9.2-1.1.5-.3.4-.4.9-.4 1.5 0 1.4.5 2 1.5 2 .4 0 .9-.1 1.6-.3v1.1c-.5.2-1.1.3-1.7.3-.9 0-1.6-.3-2-.8-.5-.5-.7-1.3-.7-2.3 0-.6.1-1.2.3-1.7.2-.5.6-.8 1-1.1.4-.3.9-.4 1.5-.4s1.2.1 1.8.4l-.4 1c-.2-.1-.5-.2-.7-.3-.3.2-.5.1-.7.1z","fill":"#F9A91E"}})])
          )
        }
      }
    